import { useContext, useEffect, useState } from 'react';
import { useNavigate } from "react-router-dom";
import evaluationIcon from '../../../assets/evaluar.svg';
import paperIcon from '../../../assets/hoja-check.svg';
import imagenMujer from '../../../assets/mujer-dinero.png';
import clockIcon from '../../../assets/reloj-circular.svg';
import { getDataTreatment } from '../../../services/mentoriaService';
import authContext from '../../../shared/src/contexts/authContext';
import Button from '../../atoms/button/button';
import './diagnosticoPartialStart.scss';

const DiagnosticoPartialStart = () => {
	const auth = useContext(authContext)
	const [hasDataTreatment, setHasDataTreatment] = useState(false);
	const navigate = useNavigate();

	useEffect(() => {
		if (auth.gigyaAccount) {
			getDataTreatment()
				.then((res) => {
					if (res.data.data) {
						setHasDataTreatment(true);
					}
				})
				.catch(err => console.error())
		}
	}, [auth.gigyaAccount])

	const handleNavegar = () => {
		if (hasDataTreatment) {
			navigate('/formulario-inicial/preguntas');
		} else {
			navigate('/formulario-inicial/tratamiento-datos')
		}
	}

	return (
		<div className='diagnostico-partial-start-container'>
			<section className='diagnostico-partial-start-container__header'>
				<div className="diagnostico-partial-start-container__header__title">
					<h2>¡Queremos conocerte!</h2>
					<h4>Alcanzar tus propósitos depende del buen manejo de tu dinero.</h4>
					<p>Para ayudarte a que te organices es importante conocerte. Por esto te haremos algunas preguntas que nos permitirán diseñar la mejor solución para el logro de tu propósito.</p>
				</div>
				<img src={imagenMujer} alt="Queremos conocerte"></img>
			</section>
			<section className='diagnostico-partial-start-container__info'>
				<div className='diagnostico-partial-start-container__info__box'>
					<img src={evaluationIcon} alt=""></img>
					<h3>Autoevaluación</h3>
					<p>No hay respuestas buenas o malas. Solo queremos conocerte.</p>
				</div>
				<span className="diagnostico-partial-start-divider"></span>
				<div className='diagnostico-partial-start-container__info__box'>
					<img src={clockIcon} alt=""></img>
					<h3>Tiempo</h3>
					<p>Te tomará menos de 5 minutos</p>
				</div >
				<span className="diagnostico-partial-start-divider"></span>
				<div className='diagnostico-partial-start-container__info__box'>
					<img src={paperIcon} alt=""></img>
					<h3>Responde con sinceridad</h3>
					<p>Esto nos permitirá darte la orientación indicada.</p>
				</div>
			</section>
			<div className="diagnostico-partial-start-container__button">
				<Button text="Comenzar" gtmClass='secondary' onClick={handleNavegar} />
			</div>
		</div>
	)
}

export default DiagnosticoPartialStart